const menuItems = [
  {
    id: 'home',
    href: '#content',
    label: 'menuHomeLabel',
    gtmLabel: 'homeId'
  },
  {
    id: 'benefits',
    i18nSectionId: 'benefitsSectionId',
    label: 'menuBenefitsLabel',
    gtmLabel: 'benefitsSectionId'
  },
  {
    id: 'earnings',
    i18nSectionId: 'earningsSectionId',
    label: 'menuEarningsLabel',
    gtmLabel: 'earningsSectionId'
  },
  {
    id: 'ourCauses',
    i18nSectionId: 'ourCausesSectionId',
    label: 'menuOurCausesLabel',
    gtmLabel: 'ourCausesSectionId'
  },
  {
    id: 'help',
    i18nSectionId: 'helpSectionId',
    label: 'menuHelpLabel',
    gtmLabel: 'helpSectionId'
  }
]

export default menuItems
